import ActionTypes from '../constants/ActionTypes';

export const setFingerPrint = fingerPrint => ({
  type: ActionTypes.SET_FINGERPRINT,
  fingerPrint,
});

export const trackSocketConnectionError = () => ({
  type: ActionTypes.TRACK_SOCKET_CONNECTION_ERROR,
});

export const trackSocketError = () => ({
  type: ActionTypes.TRACK_SOCKET_ERROR,
});

export const trackSocketDisconnected = () => ({
  type: ActionTypes.TRACK_SOCKET_DISCONNECTED,
});

export const trackFinishTest = () => ({
  type: ActionTypes.TRACK_FINISH_TEST,
});

export const trackSubmitSection = () => ({
  type: ActionTypes.TRACK_SUBMIT_SECTION,
});

export const trackTestStart = meta => ({
  type: ActionTypes.TRACK_SOCKET_DISCONNECTED,
  meta,
});

export const trackWindowFocus = meta => ({
  type: ActionTypes.TRACK_WINDOW_FOCUS,
  meta,
});

export const trackWindowBlur = meta => ({
  type: ActionTypes.TRACK_WINDOW_BLUR,
  meta,
});

export const trackChangeRoute = data => ({
  type: ActionTypes.TRACK_ROUTE_CHANGE,
  data,
});

export const trackCaptureScreen = () => ({
  type: ActionTypes.CAPTURE_SCREEN_EVENT,
});
